import {
    AffectedObject,
    AttachmentRef,
    CreateFeedbackArgs,
    FeedbackImpact,
    FeedbackType,
} from '@/features/Feedback/types';

import { AffectedTarget } from './affectedTarget';

export interface FormState {
    feedbackType: FeedbackType | null;
    expectedResult: string;
    actualResult: string;
    stepsToReproduce: string;
    impact: FeedbackImpact | null;
}

/** What was captured when the dialog opened; the customer never sees or edits it. */
export interface FeedbackContext {
    pageUrl: string;
    observedAt: string;
    target: AffectedTarget;
}

export const EMPTY_FORM_STATE: FormState = {
    feedbackType: null,
    expectedResult: '',
    actualResult: '',
    stepsToReproduce: '',
    impact: null,
};

/** The request to send, or null while the form is incomplete or invalid. */
export function buildCreateArgs(
    state: FormState,
    context: FeedbackContext,
    attachments: AttachmentRef[],
    affectedObject: AffectedObject | null,
): CreateFeedbackArgs | null {
    const expectedResult = state.expectedResult.trim();
    const actualResult = state.actualResult.trim();
    const steps = state.stepsToReproduce.trim();

    if (!state.feedbackType || !state.impact) return null;
    if (!expectedResult || !actualResult) return null;

    return {
        feedbackType: state.feedbackType,
        expectedResult,
        actualResult,
        ...(state.feedbackType === 'bug' && steps
            ? { stepsToReproduce: steps }
            : {}),
        impact: state.impact,
        affectedObject,
        pageUrl: context.pageUrl,
        observedAt: context.observedAt,
        attachments,
    };
}
